/*=========================================================================================
  File Name: module-usertax-actions.js
  Description: UserTax Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	layoutTaxPaper(state) {
		return state.TaxPaper;
	},
	layoutTaxReturnSubmission(state) {
		return state.TaxReturnSubmission;
	},
	layoutNotification(state) {
		return state.Notification;
	}
};
